import React, { useState, useEffect } from "react";
import { Chart as ChartJS, ArcElement, Title, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";

import "./InvestmentsStyles.css";

ChartJS.register(ArcElement, Title, Tooltip, Legend);

const HoldingsSection = () => {
  const prodKey = process.env.REACT_APP_PRODUCT_KEY;
  const prUrl = process.env.REACT_APP_PUBLICRATES_URL;
  const url = `${prUrl}${prodKey}_metrics.json`;

  // states
  const [fetchedData, setFetchedData] = useState([]);

  async function fetchData() {
    const response = await fetch(url);
    // console.log(response.status);
    if (!response.ok) {
      const message = `An error has occured: ${response.status}`;
      throw new Error(message);
    }
    const data = await response.json();
    // console.log(data);
    data.product.metric
      .filter((tKey) => tKey["@type_key"] === "GROUP-3")
      .map((fKey) => {
        // console.log(fKey);
        fetchedData.push(fKey);
      });
    // setFetchedData(data.product.metric);
  }

  useEffect(() => {
    fetchData();
  }, []);

  const doughnutGeneration = () => {
    return fetchedData.map((dataItems) => {
      // console.log(dataItems);
      let labelArray = [];
      let numberArray = [];
      let colorArray = [];
      Array.isArray(dataItems.values)
        ? dataItems.values.map((i) => {
            // console.log(i);
            return labelArray.push(`${i.name} - ${i.value}`);
          })
        : labelArray.push(
            `${dataItems.values.name} - ${dataItems.values.value}`
          );
      Array.isArray(dataItems.values)
        ? dataItems.values.map((i) => {
            return numberArray.push(i.numeric_value);
          })
        : numberArray.push(dataItems.values.numeric_value);
      Array.isArray(dataItems.values)
        ? dataItems.values.map((i) => {
            return colorArray.push(i.color);
          })
        : colorArray.push(dataItems.values.color);
      const options = {
        responsive: true,
        maintainAspectRatio: false,
        cutout: '70%',
        borderWidth: 0,
        autoPadding: true,
        plugins: {
          legend: {
            position: "bottom",
            labels: {
              usePointStyle: true,
              pointStyle: "circle",
              color: "black",
              padding: 20,
            },
          },
          beforeDraw(chart) {
            const { width } = chart;
            const { height } = chart;
            const ctx = chart.ctx;
            ctx.restore();

            const fontSize = (height / 100).toFixed(2);
            ctx.font = `${fontSize}em sans-serif`;
            ctx.textBaseline = "middle";

            const text = "Investment Allocation";
            const textX = Math.round((width - ctx.measureText(text).width) / 2);
            const textY = height / 2;

            ctx.fillText(text, textX, textY);
            ctx.save();
          },
        },
      };

      const data = {
        labels: labelArray,
        datasets: [
          {
            data: numberArray,
            backgroundColor: colorArray,
            cutout: "85%",
          },
        ],
      };

      return (
        <div className="doughnut-container">
          <span
            style={{
              textAlign: "center",
              display: "block",
              fontWeight: "500",
              fontSize: "22px",
              marginBottom: "12px",
            }}
          >
            {dataItems.name}
            <sup>{dataItems.footnote_key}</sup>
          </span>
          <div style={{ width: "100%", height: "320px", position: "relative" }}>
            <Doughnut data={data} options={options} />
          </div>
        </div>
      );
    });
  };

  return (
    <section id="holdings" className="holdings-wrapper">
      {doughnutGeneration()}
    </section>
  );
};

export default HoldingsSection;
